

  export const ERROR_MULTI_TIME = "error_multi_time";
  export const CAPTCHA_INVALID = "captcha_invalid";
  export const CAPTCHA_ERROR_EMPTY = "captcha_error_empty";